export default __webpack_public_path__ + "static/media/well-structured-code.33d3f22b.svg";